module.exports = __webpack_public_path__ + "media/images/rus-4b6f60bc52850dbfedd593d38478edad.jpg";